import { createSlice } from "@reduxjs/toolkit";

const initialUsersState = {
  listLoading: false,
  // actionsLoading: false,
  // totalCount: 0,
  usersCount: {},
  contestCount: {},
  tournamentCount: {},
  privatecontestCount: {},
  totalCount: {},
  scriptionPurchasedcount: {},
  amountRecivedByPackcount: {},
  scrimcount: {},
  scrimcountgame: {},
  scrimcountgamee: {},
  crmCount: {},
  overAllcontestCount: {},
  gameWiseContestCount: [],
  totalLiveVoucherCount: 0,
  voucherTransaction: [],
  totalVoucherRedeemeCount: 0,
  totalGemsusedCount: 0,
  topThreeVoucher: [],
  gameList: [],
  company: [],
  company1: [],
  wonCount: [],
  redeemReward: [],
  userCount: [],
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const UsersSlice = createSlice({
  name: "Users111",
  initialState: initialUsersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    emptyList: (state, action) => {
      state.error = null;
      // state.entities = [];
      state.totalCount = 0;
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    mainDashboardFetchedUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.usersCount = action.payload.usersCount;
      // state.crmCount = action.payload.CRM;
      // state.walletCount = action.payload.wallet;
    },
    maincontestCurrencySaved: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.contestCount = action.payload.contestCount;
      console.log("API Data:", action.payload.contestCount); // Log the API data
    },
    // maingetSubcribUserCount: (state, action) => {
    //   state.listLoading = false;
    //   state.error = null;
    //   state.maingetSubcribUserCount = action.payload.maingetSubcribUserCount;
    //   console.log("API Data:", action.payload.maingetSubcribUserCount); // Log the API data
    // },

    maingetSubcribUserCount: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.userCount = action.payload;
      console.log("API Data:", state.userCount);
    },
    maintournamentCurrencySaved: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.tournamentCount = action.payload.tournamentCount;
      console.log("API Data:", action.payload.tournamentCount); // Log the API data
    },

    mainprivatecontestCurrencySaved: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.privatecontestCount = action.payload.privatecontestCount;
      console.log("API Data:", action.payload.privatecontestCount); // Log the API data
    },

    maintotalCurrencySaved: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.totalCount = action.payload.totalCount;
      console.log("API Data:", action.payload.totalCount); // Log the API data
    },
    //scrim created
    mainscrimcreated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.scrimcount = action.payload.scrimcount;
    },
    mainsubscriptionPurchased: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.scriptionPurchasedcount = action.payload.scriptionPurchasedcount;
    },
    mainamountRecivedByPack: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.amountRecivedByPackcount = action.payload.amountRecivedByPackcount;
    },
    mainscrimgamejoining: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.scrimcount = action.payload;
    },
    mainscrimgameplatform: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.scrimcount = action.payload;
    },
    company: (state, action) => {
      const { totalCount, entities } = action.payload;
      // console.log(entities)
      state.listLoading = false;
      state.error = null;
      state.company = entities;
      // state.totalCount = totalCount;
    },
    company1: (state, action) => {
      const { totalCount, entities } = action.payload;
      // console.log(entities)
      state.listLoading = false;
      state.error = null;
      state.company1 = entities;
      // state.totalCount = totalCount;
    },
    mainscrimcreatedgame: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.scrimcountgame = action.payload;
    },
    mainscrimcreatedgamee: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.scrimcountgamee = action.payload;
    },
    gameList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.gameList = entities;
    },

    walletDashboardData: (state, action) => {
      state.listLoading = false;
      state.error = null;
      // state.usersCount = action.payload.usersCount;
      // state.crmCount = action.payload.CRM;
      state.walletCount = action.payload.wallet;
      state.wonCount = action.payload.wallet.wonCount.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      state.redeemReward = action.payload.wallet.redeemReward.sort((a, b) => {
        if (a.currencyName < b.currencyName) {
          return -1;
        }
        if (a.currencyName > b.currencyName) {
          return 1;
        }
        return 0;
      });
    },
    crmDashboardData: (state, action) => {
      state.listLoading = false;
      state.error = null;
      // state.usersCount = action.payload.usersCount;
      state.crmCount = action.payload.CRM;
      // state.walletCount = action.payload.wallet;
    },
    contestDashboardFetchedData: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.overAllcontestCount = action.payload.contestOverAll[0];
      state.gameWiseContestCount = action.payload.gameWiseCount;
    },
    rewardDashboardFetchedData: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.totalLiveVoucherCount = action.payload.totalLiveCOunt;
      state.voucherTransaction = action.payload.transactionCount;
      state.totalVoucherRedeemeCount =
        action.payload.totalVoucherRedeemeCount.length > 0
          ? action.payload.totalVoucherRedeemeCount[0].numberOfUse
          : 0;
      state.totalGemsusedCount =
        action.payload.totalVoucherRedeemeCount.length > 0
          ? action.payload.totalVoucherRedeemeCount[0].totalGemsused
          : 0;
      state.topThreeVoucher = action.payload.topThreeVoucher;
    },
    tophost: (state, action) => {
      const { totalCount, entities } = action.payload;
      console.log("totalCount, entities slice", totalCount, entities);
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // mainDashboardFetchedTotalVersion: (state, action) => {
    //     const { totalversions } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.totalversions = totalversions;
    // },
    // mainDashboardFetchedTotalPacks: (state, action) => {
    //     const { totalpacks } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.totalpacks = totalpacks;
    // },
    // mainDashboardFetchedAvatarsPurchase: (state, action) => {
    //     const { avatarspurchase } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.avatarspurchase = avatarspurchase;
    // },
    // mainDashboardFetchedAvatarsList: (state, action) => {
    //     const { avatarslist } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.avatarslist = avatarslist;
    // },
    // mainDashboardFetchedAvatarsSelected: (state, action) => {
    //     const { avatarselected } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.avatarselected = avatarselected;
    // },
    // mainDashboardFetchedBundlePurchase: (state, action) => {
    //     const { bundlepurchase } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.bundlepurchase = bundlepurchase;
    // },
    // mainDashboardFetchedAllGames: (state, action) => {
    //     const { allgames } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.allgames = allgames;
    // },
    // mainDashboardFetchedTotalColleges: (state, action) => {
    //     const { totalcolleges } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.totalcolleges = totalcolleges;
    // },
    // mainDashboardFetchedTotalFollowers: (state, action) => {
    //     const { totalfollowers } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.totalfollowers = totalfollowers;
    // },
    // mainDashboardFetchedTotalFollowings: (state, action) => {
    //     const { totalfollowings } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.totalfollowings = totalfollowings;
    // },
    // mainDashboardFetchedOneTimeBonus: (state, action) => {
    //     const { onetimebonus } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.onetimebonus = onetimebonus;
    // },
    // mainDashboardFetchedEarnCoins: (state, action) => {
    //     const { earncoins } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.earncoins = earncoins;
    // },
    // mainDashboardFetchedUnclaimedCoins: (state, action) => {
    //     const { unclaimedcoins } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.unclaimedcoins = unclaimedcoins;
    // },
    // mainDashboardFetchedRedeemVoucher: (state, action) => {
    //     const { redeemvoucher } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.redeemvoucher = redeemvoucher;
    // },
    // mainDashboardFetchedContestRatings: (state, action) => {
    //     const { contestratings } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.contestratings = contestratings;
    // },
    // mainDashboardFetchedLeagueJoining: (state, action) => {
    //     const { lgjoining } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.lgjoining = lgjoining;
    // },
    // mainDashboardFetchedLeagueJoiningUnique: (state, action) => {
    //     const { lgjoiningunique } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.lgjoiningunique = lgjoiningunique;
    // },
    // mainDashboardFetchedWinUniqueUser: (state, action) => {
    //     const { winuniqueuser } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.winuniqueuser = winuniqueuser;
    // },
    // mainDashboardFetchedWinRepeatUser: (state, action) => {
    //     const { winrepeatuser } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.winrepeatuser = winrepeatuser;
    // },
    // mainDashboardFetchedWinDistAmt: (state, action) => {
    //     const { windistamt } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.windistamt = windistamt;
    // },
    // mainDashboardFetchedLeagueJoiningRev: (state, action) => {
    //     const { lgjoiningrev } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.lgjoiningrev = lgjoiningrev;
    // },
    // mainDashboardFetchedLeagueUniquePlay: (state, action) => {
    //     const { lguniqueplay } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.lguniqueplay = lguniqueplay;
    // },
    // mainDashboardFetchedLeagueRepeatPlay: (state, action) => {
    //     const { lgrepeatplay } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.lgrepeatplay = lgrepeatplay;
    // },

    // dashboardGamesAllGamesList: (state, action) => {
    //     const { allgameslist } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.allgameslist = allgameslist;
    // },

    // // Dashboard Wallet Starts
    // dashboardWalletTotalUserLedgerList: (state, action) => {
    //     const { totalUserLedger } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalUserLedger = totalUserLedger;
    // },
    // dashboardWalletDailyRewardsCount: (state, action) => {
    //     const { dailyrewards } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     // state.totalCount = 0;
    //     state.dailyrewards = dailyrewards;
    // },
    // dashboardWalletJoinLeagueCount: (state, action) => {
    //     const { joinleague } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     // state.totalCount = 0;
    //     state.joinleague = joinleague;
    // },
    // dashboardWalletPromoCodesCount: (state, action) => {
    //     const { promocodes } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     // state.totalCount = 0;
    //     state.promocodes = promocodes;
    // },
    // dashboardWalletReferralBonusCount: (state, action) => {
    //     const { referralbonus } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     // state.totalCount = 0;
    //     state.referralbonus = referralbonus;
    // },
    // dashboardWalletRefundContestTournamentCount: (state, action) => {
    //     const { refundcontesttournament } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     // state.totalCount = 0;
    //     state.refundcontesttournament = refundcontesttournament;
    // },
    // dashboardWalletSignupBonusCount: (state, action) => {
    //     const { signupbonus } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     // state.totalCount = 0;
    //     state.signupbonus = signupbonus;
    // },
    // dashboardWalletWonLeagueCount: (state, action) => {
    //     const { wonleague } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     // state.totalCount = 0;
    //     state.wonleague = wonleague;
    // },
    // dashboardWalletAddCoinsCount: (state, action) => {
    //     const { addcoins } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     // state.totalCount = 0;
    //     state.addcoins = addcoins;
    // },
    // // Dashboard Wallet Ends

    // // Dashboard Notifications Starts
    // dashboardNotificationsEmailRetentionCount: (state, action) => {
    //     const { emailRetentionCount } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.emailRetentionCount = emailRetentionCount;
    // },
    // dashboardNotificationsPushRetentionCount: (state, action) => {
    //     const { pushRetentionCount } = action.payload;
    //     state.listLoading = false;
    //     state.error = null;
    //     state.totalCount = 0;
    //     state.pushRetentionCount = pushRetentionCount;
    // },
    // Dashboard Notifications Ends
  },
});
